import { useDispatch, useSelector } from "react-redux";
import ErrorLabel from "../../../../component/error_label";
import { actionForgotPasswordEmployerChangePswd, resetForgotPasswordEmployerChangePswdResponse } from "./store";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION, TOAST_SUCCESS_COLOR } from "../../../../common/app_constant";
import { useNavigate } from 'react-router';

const EmployerChangePswd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Form Submit 
  const {
    register,
    reset,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      password: ''
    }
  });


  // Call Api on button Click
  const onChangePasswordEmployer = (data) => {
    dispatch(actionForgotPasswordEmployerChangePswd(data));
  }

  // get api response from here
  const { forgotPasswordEmployerChangePswd } = useSelector(state => ({
    ...state.changePasswordStore,
  }))

  // if api get success show toast using useEffect - for this have to check reponse status(this will get in above code) is true then show success toast 
  useEffect(() => {
    if (forgotPasswordEmployerChangePswd !== null) {
      dispatch(resetForgotPasswordEmployerChangePswdResponse());
      if (forgotPasswordEmployerChangePswd?.status === true) {
        toast.success('Password Changed Successfully', {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        localStorage.clear(); 
        reset()
        navigate("/login")
      } else {
        switch (forgotPasswordEmployerChangePswd.status_code) {
          case 400:
            toast.error(forgotPasswordEmployerChangePswd.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          case 401:
            toast.error(forgotPasswordEmployerChangePswd.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }

    }
  }, [forgotPasswordEmployerChangePswd])

  return (
    <>
      <div className="container">
        <div className="row justify-content-center ">
          <div className="col-md-4 align-item-center mt-6">
            <div className="card">
              <div className="card-body">
                <p className="lead fw-bold text-secondary">
                  <span className="text-dark">Change Password</span>
                </p>
                <div>
                  <form onSubmit={handleSubmit(onChangePasswordEmployer)}>
                    <div class="form-group mb-2">
                      <label className="form-label" htmlFor="password">
                        Enter New Password
                      </label>
                      <input
                        type="text"
                        id="password"
                        name="password"
                        className="form-control form-control-lg"
                        placeholder="Enter a valid password id"
                        {...register("password", {
                          required: "This is required.",
                          pattern: {
                            value:
                              /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
                            message:
                              "Password must contain at least 8 characters, one letter, one number, and one special character",
                          },
                        })}
                      />
                      {errors.password && (
                        <ErrorLabel message={errors.password?.message} />
                      )}
                    </div>
                    <div className="text-center text-lg-start mt-4">
                      <button type="submit" className="btn btn-primary w-100">
                        Change Password
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployerChangePswd;
